import { Component, Inject, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { IUserConfig } from "src/app/Models/Interface/Auth/user-config";
import { AuthService } from "src/app/Services/AuthService/auth.service";
import { EAccountType } from "src/app/Models/Enum/account-type";
import { ICategory } from "src/app/Models/Interface/Category/category";
import { CategoryService } from "src/app/Services/CategoryService/category.service";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { ICountry } from "src/app/Models/Interface/Country/country";
import { CountryService } from "src/app/Services/CountryService/country.service";
import { MatDialog } from "@angular/material/dialog";
import { SelectPortForOrderComponent } from "../../Dialoges/select-port-for-order/select-port-for-order.component";
import { EMemberTeams } from "src/app/Models/Enum/member-teams";
import { ShoppingAsComponent } from "../../Dialoges/shopping-as/shopping-as.component";
import { ShoppingAsClientComponent } from "../../Dialoges/shopping-as-client/shopping-as-client.component";
import { AccountService } from "src/app/Services/AccountService/account.service";
import { IAccount } from "src/app/Models/Interface/Account/account";
import { environment } from "src/environments/environment";
import { StorageOrderService } from "src/app/Services/ShopService/StorageOrder/storage-order.service";
import { SystemNotificationService } from "src/app/Services/SystemNotification/system-notification.service";
import { ISystemNotification } from "src/app/Models/Interface/SystemNotification/system-notification";
import { UserDetailsService } from "../../Services/user-details.service";
import { EUserPermission } from "src/app/Models/Enum/user-permission";
import { DOCUMENT } from "@angular/common";
import moment from "moment";
@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  user = {} as IUserConfig;
  accountType = EAccountType;
  category = {} as IBaseDataList<ICategory[]>;
  countries: ICountry[] = [];
  memberType = EMemberTeams;
  companies = {} as IBaseDataList<IAccount[]>;
  imgSrc = environment.imgSrc;
  toggleFlag: boolean = false;
  permission = EUserPermission;
  Moment = moment;
  constructor(
    private router: Router,
    private userConfigService: UserConfigService,
    private authService: AuthService,
    private categoryService: CategoryService,
    private countryService: CountryService,
    private accountService: AccountService,
    public storageOrderService: StorageOrderService,
    public systemNotificationService: SystemNotificationService,
    public dialog: MatDialog,
    public userDetailsService: UserDetailsService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
    this.userConfigService.getUserConfig().subscribe((res) => {
      this.user = res;
    });
  }

  ngOnInit(): void {
    if (
      (this.user.isLoggedIn &&
        this.user.accountTypeCode === this.accountType.MARIHUB_PORTAL &&
        this.user.isSuperAdmin === "false") ||
      this.user.accountTypeCode === this.accountType.BUYER_PORTAL
    ) {
      this.getCategoryList();
    }        
  
    this.listenToCurrentUserNotifications();

    this.getCountryList();
  }

  isDirectoryPath(path: string): boolean {
    return this.router.url.includes(path);
  }

  listenToCurrentUserNotifications(): void {
    if (this.user.isLoggedIn) {
      this.systemNotificationService._hubConnection
        .start()
        .then(() => {
          this.systemNotificationService._hubConnection.invoke(
            "RegisterConnection",
            this.user.userId
          );
        })
        .then(() => {
          this.systemNotificationService._hubConnection.invoke(
            "SyncNotifications",
            this.user.userId
          );
        });

      this.systemNotificationService._hubConnection.on(
        "SyncNotifications",
        (notification: IBaseDataList<ISystemNotification[]>) => {          
          this.systemNotificationService.signalData = notification;
        }
      );
    }
  }

  clearCurrentUserNotifications(): void {
    this.systemNotificationService.terminateConnection();
  }

  logOut(): void {
    this.authService.clearCookie();
    this.clearCurrentUserNotifications();
    this.userConfigService.setUserConfig({
      name: "",
      profileImg: "",
      isSuperAdmin: null,
      accountTypeCode: "",
      companyName: "",
      isLoggedIn: false,
      token: "",
      emailAddress: "",
      currencyCode: "",
      accountId: null,
      currencyId: null,
      userId: null,
      roleCode: "",
      roleId: null,
      userPermissionsLists: [],
      displayBoardingVideo: false,
    });
    this.router.navigate(["auth", "sign-in"]);
  }

  getCategoryList(): void {
    this.categoryService.getCategoryList().subscribe((res) => {
      this.category = res;
      localStorage.setItem("categoryList", JSON.stringify(this.category));
    });
  }

  getCountryList(): void {
    this.countryService.getCountries(true).subscribe((res) => {
      this.countries = res;
    });
  }

  selectPortForShop(categoryId: number): void {
    if (this.storageOrderService.getOrder()?.orderId) {
      if (this.user.roleCode === this.memberType.Sales_Team) {
        this.router.navigate(["shop", categoryId], {
          queryParams: {
            countryId: this.storageOrderService.getOrder().selectedCountryId,
            portId: this.storageOrderService.getOrder().selectedPort,
            userId: this.storageOrderService.getOrder().buyerUserId,
            userName: this.storageOrderService.getOrder().userName,
            isMariHub: false,
            companyName: this.storageOrderService.getOrder().companyName,
            companyId: this.storageOrderService.getOrder().companyId,
          },
        });
      } else {
        this.router.navigate(["shop", categoryId], {
          queryParams: {
            countryId: this.storageOrderService.getOrder().selectedCountryId,
            portId: this.storageOrderService.getOrder().selectedPort,
          },
        });
      }
    } else {
      const dialogRef = this.dialog.open(SelectPortForOrderComponent, {
        minWidth: "50vw",
        maxWidth: "50vw",
        maxHeight: "95vh",
        data: {
          countries: this.countries,
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          if (this.user.roleCode === this.memberType.Sales_Team) {
            this.onOpenShoppingAsDialogue(
              res.countryId,
              res.portId,
              categoryId
            );
          } else {
            this.router.navigate(["shop", categoryId], {
              queryParams: { countryId: res.countryId, portId: res.portId },
            });
          }
        }
      });
    }
  }

  onOpenShoppingAsDialogue(
    countryId: number,
    portId: number,
    categoryId: number
  ): void {
    const dialogRef = this.dialog.open(ShoppingAsComponent, {
      minWidth: "50vw",
      maxWidth: "50vw",
      maxHeight: "95vh",
      data: {
        mariHubSalesId: this.user.accountId,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (res === "marihub") {
          this.router.navigate(["shop", categoryId], {
            queryParams: {
              countryId: countryId,
              portId: portId,
              isMariHub: true,
            },
          });
        } else {
          this.onOpenDialogueAsClient(countryId, portId, categoryId);
        }
      }
    });
  }

  onOpenDialogueAsClient(
    countryId: number,
    portId: number,
    categoryId: number
  ): void {
    this.accountService.getClientsListForShoppingAs().subscribe(
      (res) => {
        this.companies = res;
      },
      (error) => {},
      () => {
        const dialogRef = this.dialog.open(ShoppingAsClientComponent, {
          minWidth: "50vw",
          maxWidth: "50vw",
          maxHeight: "95vh",
          data: {
            companies: this.companies.data,
          },
        });

        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.router.navigate(["shop", categoryId], {
              queryParams: {
                countryId: countryId,
                portId: portId,
                userId: res.user.id,
                userName: res.user.name,
                isMariHub: false,
                companyName: res.company.name,
                companyId: res.company.id,
              },
            });
          }
        });
      }
    );
  }

  onReadNotify(notify: ISystemNotification): void {
    this.systemNotificationService.onReadNotify(notify.id).subscribe(
      (res) => {
        if (res.success) {
          notify.isRead = true;
          this.systemNotificationService.signalData.data = [
            ...this.systemNotificationService.signalData.data,
          ];
          if (this.systemNotificationService.signalData.count !== 0) {
            this.systemNotificationService.signalData.count--;
          }
        }
      },
      (error) => {},
      () => {
        // this.router.navigate([
        //   "order",
        //   notify.orderId,
        //   "summary",
        //   notify.orderId,
        // ]);
      }
    );
  }

  onToggleMenu(): void {
    this.toggleFlag = !this.toggleFlag;

    if (this.toggleFlag) {
      document.body.classList.add("lock-scroll");
    } else {
      document.body.classList.remove("lock-scroll");
    }
  }

  onToggleMenuShop(): void {
    this.onNavigateToShop();
    this.onToggleMenu();
  }

  onNavigateToShop(): void {
    if (this.user.roleCode === EMemberTeams.Buyer_Custom_Role) {
      this.router.navigate([
        "shopping",
        "shopping-buyer",
        this.category.data[0].id,
      ]);
    } else if (this.user.roleCode === EMemberTeams.Sales_Team) {
      this.router.navigate([
        "shopping",
        "shopping-sales",
        this.category.data[0].id,
      ]);
    }
  }
}
